export default function MinimumAmountHint() {
  return (
    <p className="text-[11px] text-muted-foreground">
      Valor mínimo: R$ 20,00
    </p>
  );
}
